// extracted by mini-css-extract-plugin
module.exports = {"sider__control__left":"SiderControl_sider__control__left__22X4-"};